import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {

  pdfFile: string = '';

  constructor(
      public dialogRef: MatDialogRef<PdfViewerComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { criteria:any }
    ) {
      // console.log(data.criteria.questionFile);
      
    }

  ngOnInit(): void {

    this.pdfFile = environment.baseUrl + this.data.criteria;
    console.log(this.pdfFile);

  }

}
